<template>
    <transition name="history-toast">
        <div v-if="toast" :key="toast.id" class="history-toast" role="status">
            <span class="history-toast-msg">{{ toast.label }}</span>
            <button type="button" class="history-toast-action" @click="onAction">
                {{ toast.mode === 'undo' ? $t('history.undo') : $t('history.redo') }}
            </button>
        </div>
    </transition>
</template>

<script>
import { HISTORY_TOAST_MS, hideHistoryToast, history, redoHistory, undoHistory } from '@/utils/History'

export default {
    name: 'HistoryToast',
    computed: {
        toast() {
            return history.toast
        },
    },
    beforeDestroy() {
        clearTimeout(this._timer)
    },
    methods: {
        onAction() {
            const toast = this.toast
            if (!toast) return
            hideHistoryToast(toast.id)
            if (toast.mode === 'undo') undoHistory(toast.context)
            else redoHistory(toast.context)
        },
    },
    watch: {
        toast(val) {
            clearTimeout(this._timer)
            if (!val) return
            const id = val.id
            this._timer = setTimeout(() => hideHistoryToast(id), HISTORY_TOAST_MS)
        },
    },
}
</script>

<style scoped>
.history-toast {
    position: fixed;
    left: 50%;
    top: calc(20px + var(--safe-area-inset-top, 0px));
    transform: translateX(-50%);
    z-index: 10000;
    display: flex;
    align-items: center;
    gap: 4px;
    max-width: calc(100vw - 32px);
    padding: 6px 6px 6px 16px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline2-base);
    border-radius: 12px;
    box-shadow: 0 12px 40px rgba(15, 22, 35, .15);
    font-size: 13px;
    color: var(--v-txtPrimary-base);
}

.theme--dark .history-toast {
    box-shadow: 0 20px 60px rgba(0, 0, 0, .5);
}

.history-toast-msg {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.history-toast-action {
    height: 34px;
    padding: 0 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .05em;
    text-transform: uppercase;
    white-space: nowrap;
    color: var(--v-accent-base);
}

.history-toast-action:hover {
    background: rgba(51, 153, 153, .1);
}

.theme--dark .history-toast-action {
    color: var(--v-primary-base);
}

.theme--dark .history-toast-action:hover {
    background: rgba(204, 255, 51, .1);
}

.history-toast-enter-active,
.history-toast-leave-active {
    transition: opacity .2s, transform .2s;
}

.history-toast-enter,
.history-toast-leave-to {
    opacity: 0;
    transform: translate(-50%, -16px);
}
</style>
